export default "<b> {fee} </b> / {frequency}\n\n<strong> {interestRate} </strong> p.a. interest rate\n";